import { IconProp } from "@fortawesome/fontawesome-svg-core";
import * as React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage, MessageDescriptor } from "react-intl";

type SectionProps = {
    icon: IconProp;
    label: MessageDescriptor;
    children: React.ReactNode;
    containerStyle?: React.CSSProperties;
    labelExtra?: React.ReactNode;
};

const Section = ({ children, icon, label, labelExtra, containerStyle }: SectionProps) => (
    <Stack>
        <div style={{ display: "flex", alignItems: "center" }}>
            <FontAwesomeIcon size="lg" icon={icon} style={{ marginRight: 10 }} />
            <div style={{ marginRight: 10 }}>
                <Typography variant="h6">
                    <FormattedMessage {...label} />
                </Typography>
            </div>
            {labelExtra}
            <Divider style={{ flexGrow: 1 }} />
        </div>
        <Box style={containerStyle}>{children}</Box>
    </Stack>
);

export default Section;
